// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 10198); hand-edits allowed (see docs/architecture.md)

/** `this.TASK_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_TASK_DEF(): any {
  return [
    31,
    { "bonus_type": "gold", "bonus": 500, "name": "Пройти одну карьеру" },
    { "bonus_type": "exp", "bonus": 300, "name": "Купить стимулятор" },
    { "bonus_type": "gold", "bonus": 1000, "name": "Получить новый уровень" },
    { "bonus_type": "exp", "bonus": 500, "name": "Купить оружие 2 класса" },
    { "bonus_type": "gold", "bonus": 2000, "name": "Пройти одно выживание" },
    { "bonus_type": "exp", "bonus": 400, "name": "Использовать 2 стимулятора" },
    { "bonus_type": "exp", "bonus": 600, "name": "Купить флаг" },
    { "bonus_type": "gold", "bonus": 2500, "name": "Пройти одну миссию" },
    { "bonus_type": "diam", "bonus": 3, "name": "Получить новый уровень" },
    { "bonus_type": "exp", "bonus": 750, "name": "Купить оружие 3 класса" },
    { "bonus_type": "gold", "bonus": 800, "name": "Сыграть в дартс" },
    { "bonus_type": "gold", "bonus": 3000, "name": "Пройти одно выживание" },
    { "bonus_type": "exp", "bonus": 650, "name": "Выбрать новую способность" },
    { "bonus_type": "gold", "bonus": 3000, "name": "Пройти одну миссию" },
    { "bonus_type": "exp", "bonus": 700, "name": "Разобрать одно оружие" },
    { "bonus_type": "exp", "bonus": 1000, "name": "Купить оружие 4 класса" },
    { "bonus_type": "exp", "bonus": 1100, "name": "Улучшить одно оружие" },
    { "bonus_type": "diam", "bonus": 5, "name": "Победить одного босса" },
    { "bonus_type": "exp", "bonus": 3000, "name": "Добавить червяка или увеличить здоровье" },
    { "bonus_type": "exp", "bonus": 1300, "name": "Собрать одно оружие" },
    { "bonus_type": "exp", "bonus": 1500, "name": "Купить одно энергооружие" },
    { "bonus_type": "gold", "bonus": 3000, "name": "Выбрать новую способность" },
    { "bonus_type": "gold", "bonus": 3000, "name": "Пройти одну карьеру на Кошмаре" },
    { "bonus_type": "exp", "bonus": 1400, "name": "Украсть оружие" },
    { "bonus_type": "diam", "bonus": 2, "name": "Собрать оружие 3 класса" },
    { "bonus_type": "diam", "bonus": 10, "name": "Победить одного босса" },
    { "bonus_type": "diam", "bonus": 6, "name": "Собрать оружие 4 класса" },
    { "bonus_type": "exp", "bonus": 5000, "name": "Захватить территорию" },
    { "bonus_type": "exp", "bonus": 7000, "name": "Купить имплантант" },
    { "bonus_type": "exp", "bonus": 8000, "name": "Собрать оружие 5 класса" },
    { "bonus_type": "", "bonus": 0, "name": "Поздравляем!" }
  ];
}
